import { MAX_TEXT_LENGTH } from "@/constants/common";
import { INVALID_STRING_LATIN } from "@/constants/invalids";
import {
  STANDARD_INDUSTRY_CODE_LENGTH,
  STANDARD_INDUSTRY_GROUP_CODE_MAX_LENGTH,
  STANDARD_INDUSTRY_LEVEL,
  STANDARD_INDUSTRY_LEVEL_LABEL,
  TStandardIndustryLevel,
} from "@/features/master-data/constants/standardIndustry";
import { replaceStr } from "@/utils/string";
import { validator } from "@/utils/validator";

const GROUP_CODE_PATTERN = /^[A-Z]+$/;

// 大分類 (group) — `code` is up to 3 half-width uppercase letters.
export const standardIndustryGroupSchema = validator.object().shape({
  code: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .transform((value) => (typeof value === "string" ? value.normalize("NFKC").toUpperCase() : value))
    .test("groupCodeLatin", function (value) {
      if (!value || GROUP_CODE_PATTERN.test(value)) {
        return true;
      }
      return this.createError({ message: ({ label }) => replaceStr(INVALID_STRING_LATIN, { path: label }) });
    })
    .max(STANDARD_INDUSTRY_GROUP_CODE_MAX_LENGTH)
    .label("大分類コード")
    .required(),
  name: validator.string().emptyToNull().max(MAX_TEXT_LENGTH).label("大分類名").required(),
});

// 中/小/細分類 create/edit — `code` is a numeric segment whose length depends on the level.
export const makeStandardIndustryClassificationSchema = (level: TStandardIndustryLevel) => {
  const codeSchema = validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .transform((value) => (typeof value === "string" ? value.normalize("NFKC") : value))
    .numbersOnly();
  const codeLength = STANDARD_INDUSTRY_CODE_LENGTH[level];

  return validator.object().shape({
    code: (level === STANDARD_INDUSTRY_LEVEL.MAJOR ? codeSchema.max(codeLength) : codeSchema.length(codeLength))
      .label(`${STANDARD_INDUSTRY_LEVEL_LABEL[level]}コード`)
      .required(),
    name: validator.string().emptyToNull().max(MAX_TEXT_LENGTH).label("分類名").required(),
  });
};
